<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="名称" prop="name">
            <el-input placeholder="请输入名称" v-model="rule.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入描述" v-model="rule.desc" clearable></el-input>
        </el-form-item>
        <el-form-item label="选择权限" prop="perms">
            <el-tree
                ref="tree"
                :data="treeData"
                show-checkbox
                node-key="id"
                @check-change="handleNodeClick"
                :props="defaultProps">
            </el-tree>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import axios from 'axios';
var attributes = {    //定义数据属性名称
    id: 'id',
    parentId: 'pid',
    name: 'title',
    rootId: 0
}
    export default {
        data() {
            return {
                name: 'edit',
                id:0,
                rule: {
                    id:0,
                    name: '',
                    desc: '',
                    perms: '',
                },
                rules: {
                    name: { required: true, message: '请输入名称' },
                    desc: {required: true, message: '请输入描述'},
                    perms: {required: true, message: '请选择权限'},
                },
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
            }
        },
        async mounted() {
            //获取权限tree
            this.$http.get('/manage/perm/permAll').then(result=> {
                this.treeData = this.tree(result['data']['data'],attributes);
            });
            if(this.$route.params.id) {
                if(this.$store.state.roleInfo.length == 0) {
                    this.$router.push('/setting/role/index');
                }else {
                    //回显
                    this.rule = this.$store.state.roleInfo;
                    let keys = [];
                    for(let x of this.$store.state.roleInfo.perms) {
                        keys.push(x.id);
                    }
                    this.$refs.tree.setCheckedKeys(keys);
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        this.rule.perms = this.$refs.tree.getCheckedKeys();
                        if(this.rule.id == 0) {
                            this.$http.post('/manage/role/add',this.rule).then((rs) => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.go(-1);
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            this.$http.post('/manage/role/edit',this.rule).then((rs) => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.go(-1);
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            }).catch((e)=> {
                                this.$message({
                                    message: e.message,
                                    type: 'error'
                                });
                            })
                        }
                        
                    }
                });
            },
            block() {
                this.$router.go(-1);
            },
            handleNodeClick(data) {
                this.rule.perms = this.$refs.tree.getCheckedKeys();
            },
            tree(data, attributes) {
                let resData = data;
                let tree = [];
                for(let i = 0; i < resData.length; i++) {
                    if(resData[i][attributes.parentId] === attributes.rootId) {
                        let obj = {
                            id: resData[i][attributes.id],
                            label: resData[i][attributes.name],
                            children: []
                        };
                        tree.push(obj);
                        resData.splice(i, 1);
                        i--;
                    }
                }
                run(tree);

                function run(chiArr) {
                    if(resData.length !== 0) {
                        for(let i = 0; i < chiArr.length; i++) {
                            for(let j = 0; j < resData.length; j++) {
                                if(chiArr[i].id == resData[j][attributes.parentId]) {
                                    let obj = {
                                        id: resData[j][attributes.id],
                                        label: resData[j][attributes.name],
                                        children: []
                                    };
                                    chiArr[i].children.push(obj);
                                    resData.splice(j, 1);
                                    j--;
                                }
                            }
                            run(chiArr[i].children);
                        }
                    }
                }
                return tree;
            }
        }
    }
</script>